import { api } from "@/api/client";

export type ReferralGrantRole = "USER" | "LEADER";

export interface BindReferralResult {
  inviter_display_name: string;
  grant_role: ReferralGrantRole;
}

export function bindReferralCode(code: string) {
  return api<BindReferralResult>("/referrals/bind", {
    method: "POST",
    json: { code },
  });
}
